import { ClassNameProps, makeClassName, StyleProps } from "@hex-insights/core";
import { Badge } from "../../../../../Components/Badge";
import styles from "./styles.module.css";

export type AttendanceRating = "excellent" | "good" | "average" | "below-average";

export type AttendanceRatingBadgeProps = {
	rating: AttendanceRating;
} & Partial<ClassNameProps & StyleProps>;

export function AttendanceRatingBadge({ rating, className, style }: AttendanceRatingBadgeProps) {
	return (
		<Badge
			className={makeClassName(
				styles["attendance-rating-badge"],
				styles[`attendance-rating-badge--${rating}`],
				className,
			)}
			style={style}
		>
			{ratingText(rating)}
		</Badge>
	);
}

function ratingText(variant: AttendanceRating) {
	switch (variant) {
		case "excellent":
			return "Excellent";
		case "good":
			return "Good";
		case "average":
			return "Average";
		case "below-average":
			return "Below Average";
	}
}
